import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _typeof from "@babel/runtime/helpers/typeof";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.date.to-json.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.constructor.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.repeat.js";
import "core-js/modules/web.dom-collections.for-each.js";
// Translations
import translations from "./translations/formatter.translations";
// Types

var expandFormatRepetitions = function expandFormatRepetitions(format) {
  return format.reduce(function __reducePatterns(patterns, nextItem) {
    if (+nextItem.repeat > 1) {
      var expanded = [];
      var copy = _objectSpread({}, nextItem);
      delete copy.repeat;
      for (var i = 0; i < +nextItem.repeat; i += 1) {
        expanded.push(_objectSpread({}, copy));
      }
      return [].concat(_toConsumableArray(patterns), expanded);
    }
    return [].concat(_toConsumableArray(patterns), [nextItem]);
  }, []);
};
var manageCharSpec = function manageCharSpec(_ref) {
  var characters = _ref.characters,
    formattedValue = _ref.formattedValue,
    rawValue = _ref.rawValue,
    pattern = _ref.pattern;
  var charRexp;
  if (_typeof(pattern["char"]) === 'object' && typeof pattern["char"].test === 'function') {
    charRexp = pattern["char"];
  } else if (Array.isArray(pattern["char"]) && pattern["char"].length >= 1) {
    var _pattern$char = _slicedToArray(pattern["char"], 2),
      rexp = _pattern$char[0],
      _pattern$char$ = _pattern$char[1],
      mod = _pattern$char$ === void 0 ? '' : _pattern$char$;
    charRexp = new RegExp(rexp, mod);
  } else if (typeof pattern["char"] === 'string') {
    charRexp = new RegExp(pattern === null || pattern === void 0 ? void 0 : pattern["char"]);
  }
  while (characters.length > 0 && ((_charRexp = charRexp) === null || _charRexp === void 0 ? void 0 : _charRexp.test(characters[0])) !== true) {
    var _charRexp;
    characters.shift();
  }
  if (characters.length > 0) {
    formattedValue += characters[0];
    rawValue += characters[0];
    characters.shift();
  }
  return {
    formattedValue: formattedValue,
    rawValue: rawValue
  };
};
var formatter = function formatter(_ref2) {
  var formatSpecs = _ref2.formatSpecs,
    value = _ref2.value;
  var format = expandFormatRepetitions(formatSpecs);
  if (format.length > 0) {
    var characters = value.split('');
    var formattedValue = '',
      rawValue = '';
    while (format.length > 0 && characters.length > 0) {
      var pattern = format.shift();
      if (pattern["char"]) {
        var params = {
          characters: characters,
          formattedValue: formattedValue,
          rawValue: rawValue,
          pattern: pattern
        };
        var _manageCharSpec = manageCharSpec(params),
          ftmValue = _manageCharSpec.formattedValue,
          rawV = _manageCharSpec.rawValue;
        formattedValue = ftmValue || formattedValue;
        rawValue = rawV || rawValue;
      } else if (typeof pattern.exactly === 'string') {
        if (pattern.exactly.length !== 1) {
          throw new Error("".concat(translations.EXCEPTION_INVALID_EXACTLY, " ").concat(pattern.exactly));
        }
        formattedValue += pattern.exactly;
        if (pattern.exactly === characters[0]) {
          characters.shift();
        }
      } else {
        throw new Error("".concat(translations.EXCEPTION_INVALID_FORMAT, " ").concat(JSON.stringify(pattern)));
      }
    }
    return {
      formatted: formattedValue,
      raw: rawValue
    };
  }
  return {
    formatted: value,
    raw: value
  };
};
export default formatter;